<app-dialog [config]="dialogConfig"></app-dialog>
